const searchItemsByLabel = async (value, items) => {
  return items.filter(item => new RegExp(value, 'i').test(item.label));
};

export { searchItemsByLabel as s };
